import locale from '../locale/default';

export default locale;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/locale-provider/default.js
// module id = 117
// module chunks = 0